export default __webpack_public_path__ + "static/media/spheres-other.e3796d0b.mp3";